import React, { Component } from 'react'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import * as teacherActions from '@app/actions/teachers'

export function normalizeStudents(Component) {
  class StudentNormalizer extends React.Component {
    render() {
      const {forwardedRef, classes, ...rest} = this.props;
      let students = _
        .chain(classes.objects)
        .mapValues('students')
        .values()
        .flatMap(_.values)
        .map('object')
        .value()

      return (
        <Component ref={forwardedRef}
          students={students}
          classes={classes}
          {...rest}
        />
      )
    }
  }

  return React.forwardRef((props, ref) => {
    return <StudentNormalizer {...props} forwardedRef={ref} />;
  });
}

class ClassesContainer extends Component {
  componentDidMount() {
    this.props.boundActions.fetchClassesIfNeeded()
  }

  render() {
    const { ChildComponent, ...rest } = this.props
    return (<ChildComponent {...rest} />)
  }
}

const mapStateToProps = (state) => {
  const { teachers: { classes } } = state
  return { classes }
}

const mapDispatchToProps = (dispatch) => {
  const boundActions = bindActionCreators(teacherActions, dispatch)
  return { boundActions }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(ClassesContainer)
